import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M23.652 6.92723L17.16 0.418751C16.932 0.191433 16.632 0 16.308 0H7.2V0.0598059C5.88 0.0598059 4.8 1.1605 4.8 2.48852V2.52441V16.8813C4.8 18.1974 5.88 19.2144 7.2 19.2144V19.1426H21.6V19.2024C22.92 19.2024 24 18.1615 24 16.8454V7.80059C24 7.47755 23.868 7.14258 23.652 6.92723ZM21.6 15.673C21.6 16.331 21.06 16.7498 20.4 16.7498H8.4C7.74 16.7498 7.2 16.343 7.2 15.673V3.70888C7.2 3.05086 7.74 2.39282 8.4 2.39282H14.4V7.29811C14.4 8.61417 15.48 9.57129 16.8 9.57129H21.6V15.673ZM19.2 22.7677V22.8036C19.2 23.4616 18.66 23.9402 18 23.9402H2.4V24C1.08 24 0 22.995 0 21.667V6.11364C0 5.45562 0.54 4.91723 1.2 4.91723C1.86 4.91723 2.4 5.45562 2.4 6.11364V20.4706C2.4 21.1286 2.94 21.5474 3.6 21.5474H18C18.66 21.5354 19.2 22.0977 19.2 22.7677Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
